import { Component,
         OnInit,
         ViewEncapsulation,
         Input }                  from '@angular/core';
import { AppleInfoTextPlacement, MediaModel, WalletInfo }             from '../../../common/media.model';
import { CompanyService }         from '../../../shared/company.service';
import { Globals }                from '../../../common/globals';
import { DomSanitizer, SafeStyle }           from 'node_modules/@angular/platform-browser';
import { WalletBarcodeType }      from '../../../common/wallet-barcode-type.enum';
import { WalletTemplateModel }    from '../../../common/wallet-template.model';
import { WalletCommon, EvaluatedField } from '../wallet-common/wallet-common.functions';
import { WalletAppleField } from './wallet-apple-field.enum';
import { CompanyViewModel } from '../../../common/transaction-header.model';
import { GalleryService } from '../../../shared/gallery.service';
import { Honeycomb } from 'src/app/shared/honeycomb-api/honeycomb-api';

@Component({
  selector: 'hc-wallet-iphone',
  templateUrl: './wallet-iphone.component.html',
  styleUrls: ['./wallet-iphone.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WalletIphoneComponent extends WalletCommon implements OnInit  {

  private _globals: Globals;
  get getGlobals() {
    return this._globals;
  }

  private _sanitizer: DomSanitizer;
  get getSanitizer() {
    return this._sanitizer;
  }
  public activeCompany: Honeycomb.Tenant.Admin.IService.ViewModels.CompanyViewModel;

  @Input()
  public mediaModel: MediaModel;

  @Input()
  public walletTemplate: WalletTemplateModel;

  public walletBarcodeType = WalletBarcodeType;

  public walletInfos: any[];

  constructor(
    sanitizer: DomSanitizer,
    globals: Globals,
    service: GalleryService,
    private companyService: CompanyService
  ) {
    super(globals, sanitizer, service);
    this._globals = globals;
    this._sanitizer = sanitizer;
  }

  async ngOnInit() {
    this.companyService.setCompanyID = this.mediaModel.companyID;
    this.activeCompany = await this.companyService.getActive().toPromise()
                                                  .catch((e) => {
                                                    return null;
                                                  });
  }

  private getAppleFieldValue(fieldType: WalletAppleField): string {
    return this.getFieldValue(fieldType, this.walletTemplate, this.mediaModel);
  }

  private getAppleFieldLabel(fieldType: WalletAppleField): string {
    return this.getFieldLabel(fieldType, this.walletTemplate, this.mediaModel);
  }

  private getAppleFields(fieldType: WalletAppleField): EvaluatedField[] {
    return this.getFields(fieldType, this.walletTemplate, this.mediaModel);
  }

  get getLogoText(): string {
    return this.getAppleFieldValue(WalletAppleField.LogoText);
  }

  get getLogoTextLabel(): string {
    return this.getAppleFieldLabel(WalletAppleField.LogoText);
  }

  get getHeader(): string {
    return this.getAppleFieldValue(WalletAppleField.Header);
  }

  get getHeaderLabel(): string {
    return this.getAppleFieldLabel(WalletAppleField.Header);
  }

  get getPrimary(): EvaluatedField[] {
    return this.getAppleFields(WalletAppleField.Primary);
  }

  get getSecondary(): EvaluatedField[] {
    const res = this.getAppleFields(WalletAppleField.Secondary);
    if (this.mediaModel) {
      this.mediaModel.walletInfos.filter( i => i.appleInfoTextPlacement === AppleInfoTextPlacement.Secondary )
                                 .sort( (a, b) => a.sortOrder - b.sortOrder )
                                 .forEach( i => {
        res.push( <EvaluatedField> {
           text: i.infoText,
           label: i.infoName
        });
      });
    }
    return res;
  }

  get getAuxiliary(): EvaluatedField[] {
    const res = this.getAppleFields(WalletAppleField.Auxiliary);
    if (this.mediaModel) {
      this.mediaModel.walletInfos.filter( i => i.appleInfoTextPlacement === AppleInfoTextPlacement.Auxiliary )
                                 .sort( (a, b) => a.sortOrder - b.sortOrder )
                                 .forEach( i => {
        res.push( <EvaluatedField> {
           text: i.infoText,
           label: i.infoName
        });
      });
    }
    return res;
  }

  // get getAuxiliaryLabel(): string {
  //   return this.getAppleFieldValue(WalletAppleField.Auxiliary);
  // }

  get getBack(): EvaluatedField[] {
    return this.getAppleFields(WalletAppleField.Back);
  }

  get getBackgroundColor(): string {
    return this.getAppleFieldValue(WalletAppleField.BackgroundColor);
  }

  get getLabelColor(): string {
    return this.getAppleFieldValue(WalletAppleField.LabelColor);
  }

  get getForegroundColor(): string {
    return this.getAppleFieldValue(WalletAppleField.ForegroundColor);
  }

  get getBarcodeValue(): string {
    return this.getAppleFieldValue(WalletAppleField.BarcodeValue);
  }

  get getLogoImage(): string {
    return this.getAppleFieldValue(WalletAppleField.LogoImage);
  }

  get getLogoImageUrl(): SafeStyle {
    if (this.mediaModel && this.mediaModel.walletLogoUID) {
      return this.getImage( this.mediaModel.walletLogoUID);
    }
    return this.getImage(this.getAppleFieldValue(WalletAppleField.LogoImage));
  }

  get getIconImage(): string {
    return this.getAppleFieldValue(WalletAppleField.IconImage);
  }

  get getIconImageUrl(): SafeStyle {
    return this.getImage(this.getAppleFieldValue(WalletAppleField.IconImage));
  }

  get hasThumbnailImage(): boolean {
    return !!this.getAppleFieldValue(WalletAppleField.ThumbnailImage);
  }

  get getThumbnailImageUrl(): SafeStyle {
    return this.getImage(this.getAppleFieldValue(WalletAppleField.ThumbnailImage));
  }

  get hasStripImage(): boolean {
    return !!this.getAppleFieldValue(WalletAppleField.StripImage);
  }

  get getStripImageUrl(): SafeStyle {
    if (this.mediaModel && this.mediaModel.walletImageUID) {
      return this.getImage( this.mediaModel.walletImageUID);
    }
    return this.getImage(this.getAppleFieldValue(WalletAppleField.StripImage));
  }

  get getAdditionalInfo(): WalletInfo[] {
    if (this.mediaModel) {
      return this.mediaModel.walletInfos.filter( i => i.appleInfoTextPlacement === AppleInfoTextPlacement.Back );
    }
    return null;
  }
}
